module.exports = __webpack_public_path__ + "static/media/company-building.593bfe73.svg";